import md5 from 'md5';
import { useEffect, useMemo } from 'react';
import { useStorageState } from 'react-storage-hooks';

interface ImageCachedProps {
  imageSrc: string;
  isLoading?: boolean;
  isMobile?: boolean;
}

export const useImageCached = ({
  imageSrc = '',
  isLoading = true,
  ...props
}: ImageCachedProps): [boolean] => {
  const [cachedImages, setImageCached] = useStorageState<string[]>(
    sessionStorage,
    'IMAGES-CACHED',
    [],
  );
  const hashedImage = useMemo(() => md5(JSON.stringify({ imageSrc, ...props })), [imageSrc, props]);
  const isImageCached = useMemo(
    () => !!cachedImages.find((hash) => hashedImage === hash),
    [cachedImages, hashedImage],
  );

  useEffect(() => {
    if (isImageCached) return;
    if (isLoading) return;

    setImageCached((prev) => [...prev, hashedImage]);
  }, [hashedImage, isImageCached, setImageCached, isLoading]);

  return [isImageCached];
};
